// extracted by mini-css-extract-plugin
export var container = "_lc-0";
export var dotAnimation = "_lc-2";
export var dotsLoading = "_lc-1";